import Row from 'components/Row';
import React from 'react';
import { Typography, Dialog, AppBar, Toolbar, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import NewForumPost from './newForumPost/NewForumPost';
import styled from 'styled-components';

export default function EditModal({ open, handleClose, forum }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{ square: true }}
    >
      <AppBar style={{ width: 600 }} position="static" color="primary">
        <Toolbar>
          <Row align="center" justify="space-between">
            <Typography variant="h6">Edit Post</Typography>
            <Button>
              <CloseIcon style={{ color: 'white' }} onClick={handleClose} />
            </Button>
          </Row>
        </Toolbar>
      </AppBar>
      <div style={{ padding: 10 }}>
        <NewForumPost edit post={forum} onClose={handleClose} />
      </div>
    </Dialog>
  );
}
